import { ElementType, Planet } from '@apeiron/planet'
import { NextImage } from '@apeiron/temp'
import { styled } from '@mui/material'
import { PlanetElementText } from '@src/components/planet/detail/planetElementSection/PlanetElementText'
import { SectionContent } from '@src/components/planet/detail/SectionContent'
import React from 'react'
import { PieChart } from 'react-minimal-pie-chart'

export const mappingElementColor: Record<ElementType, string> = {
  [ElementType.Fire]: '#E86643',
  [ElementType.Water]: '#6EEAE6',
  [ElementType.Air]: '#8EE161',
  [ElementType.Earth]: '#B9B1A3',
  [ElementType.None]: '#333333' // we won't use this color
}

const ContentContainer = styled('div')`
  display: flex;
  position: relative;
  height: 175px;
  background-color: #343637;
  justify-content: center;
`

const Chart = styled(PieChart)`
  width: 135px;
  height: 135px;
`

const ElementImageContainer = styled('div')`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
`

const ElementImage = styled(NextImage)`
  position: absolute;
  width: 115px;
  height: 115px;
`

export const PlanetElementSection: React.FC<
  PlanetElementSectionProps
> = props => {
  const { planet, src } = props

  const elementData = [
    {
      title: 'Fire',
      value: planet.fire,
      color: mappingElementColor[ElementType.Fire]
    },
    {
      title: 'Water',
      value: planet.water,
      color: mappingElementColor[ElementType.Water]
    },
    {
      title: 'Air',
      value: planet.air,
      color: mappingElementColor[ElementType.Air]
    },
    {
      title: 'Earth',
      value: planet.earth,
      color: mappingElementColor[ElementType.Earth]
    }
  ]

  return (
    <SectionContent>
      <ContentContainer>
        <ElementImageContainer>
          <Chart startAngle={-90} data={elementData} />
          {src && <ElementImage src={src} />}
        </ElementImageContainer>
        <PlanetElementText planet={planet} />
      </ContentContainer>
    </SectionContent>
  )
}

export type PlanetElementSectionProps = {
  planet: Planet
  src: string | undefined
}
